module.exports = __webpack_public_path__ + "img/main_banner.b27a2c48.jpg";